import axios from 'axios';
import Settings from './config';

export default {
    getConfiguration(cb) {
        axios.get('/umbraco/api/golf/getConfiguration')
            .then(response => {
                cb(response.data);
            });
    },

    getTeeTimes(payload, cb) {
    
        axios.post(Settings.ENDPOINT + 'api/golf/search', payload)
            .then(response => {
                cb(response.data);
            });
    },

    createBooking(payload, sessionId, cb) {
        axios.post(Settings.ENDPOINT + 'api/golf/' + sessionId +'/create', payload)
            .then(response => {
                cb(response.data);
            });

    },
    completeBooking(payload, sessionId, cb) {
        axios.post(Settings.ENDPOINT + 'api/golf/' + sessionId + '/complete', payload)
            .then(response => {
                cb(response.data);
            });

    }



}

